// extracted by mini-css-extract-plugin
export default {"sidebar":"estimatedDeliveryDate_sidebar__DYSNz","change":"estimatedDeliveryDate_change__R8rcJ"};